
export default function handleDescargaTXT(language, user, messages, fecha) {
  
  let filename = "conversacion.txt"
  let text = "CONVERSACIÓN CON EL ASISTENTE VIRTUAL DEL DEFENSOR DEL PUEBLO: "+ fecha+ "\n";
  for (let i = 0; i < messages.length; i++) {
    let txt = "";
    let type = messages[i].type
    switch (type) {
      case "text":
        txt = (messages[i].isUser ? "-Usuario: " : "-Asistente virtual: ") + messages[i].text
        break;
      case "postback_button":
        let options = messages[i].data
        txt = (messages[i].isUser ? "-Usuario: " : "-Asistente virtual: ")
        for (let k = 0; k < options.length; k++) {
          txt += "[" + options[k].text + "]  "
        }
        break;
      case "rating":
        txt = "-Asistente virtual: ☆☆☆☆☆ (valoración en estrellas)"
        break;
      case "rated":
        let stars = "";
        for (var e = 1; e <= 5; e++) {
          if (e <= messages[i].rating) {
            stars = stars + "★"
          } else {
            stars = stars + "☆"
          }
        }
        txt = "-Usuario: " + stars + " (" + messages[i].rating + " estrellas)"
        break
      default:
        txt = "";

    }
    text = text + "\n" + txt
  }
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

